import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { canUseDOM } from '..';
function useHasClass(selector, className) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasClass = _useState2[0],
    setHasClass = _useState2[1];
  useEffect(function () {
    if (canUseDOM) {
      var element = document.querySelector(selector);
      if (element) {
        setHasClass(element.classList.contains(className));
      }
      var observer = new MutationObserver(function () {
        if (element) {
          setHasClass(element.classList.contains(className));
        }
      });
      if (element) {
        observer.observe(element, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
      return function () {
        observer.disconnect();
      };
    }
  }, [selector, className]);
  return hasClass;
}
export default useHasClass;